import { Navigate } from "react-router-dom";
import { useAuth } from "contexts/UserContext";
import { Flex, Spinner } from "@chakra-ui/react";

const GuestRoute = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <Flex minH="100vh" align="center" justify="center">
                <Spinner size="xl" color="brand.500" thickness="4px" />
            </Flex>
        );
    }

    if (user) {
        return <Navigate to="/dashboard" replace />
    }

    return children;
}

export default GuestRoute;